import * as React from 'react'

const IconCheckmark = (props) => {
  const { color } = props

  return (
    <svg width={24} height={24} xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='m5 11.8 5.132 5.2L20 7'
        stroke={color || '#00B2E3'}
        strokeWidth={3}
        fill='none'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default IconCheckmark
